import { render, staticRenderFns } from "./FeedbackQueue.vue?vue&type=template&id=38f92463"
import script from "./FeedbackQueue.vue?vue&type=script&lang=js"
export * from "./FeedbackQueue.vue?vue&type=script&lang=js"
import style0 from "./FeedbackQueue.vue?vue&type=style&index=0&id=38f92463&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports